import { client } from '../apiClient';
import { ProductResponse } from '../../models/pricing/ProductResponse';
import { AccountType } from '../../types/account/AccountType';
import { NextPaymentResponse } from '../../models/pricing/NextPaymentResponse';
import { BillingDataResponse } from '../../models/user/data/BillingDataResponse';
import { DiscountResponseData } from '../../models/pricing/DiscountResponse';
import { BillingReport } from '../../models/pricing/BillingReport';

const BILLING_ENDPOINT = '/billing';

export const checkCurrentAndChangePlan = async (
  priceId: string,
  accountType: AccountType
): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`${BILLING_ENDPOINT}/change-plan`, { priceId, accountType })
    .then((response) => response.data);
};

export const getProductsData = async (): Promise<ProductResponse> => {
  return client(true, true)
    .get<ProductResponse>(`${BILLING_ENDPOINT}/products`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getTransactionsData = async (): Promise<any> => {
  return client(true, true)
    .get<any>(`${BILLING_ENDPOINT}/transactions`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const prepareUpdatePaymentMethod = async (): Promise<string> => {
  return client(true, true)
    .get<string>(`${BILLING_ENDPOINT}/prepare-update-payment`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updatePaymentMethod = async (): Promise<string> => {
  return client(true, true)
    .post<string>(`${BILLING_ENDPOINT}/update-payment`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getNextPayment = async (): Promise<NextPaymentResponse> => {
  return client(true, true)
    .get<NextPaymentResponse>(`${BILLING_ENDPOINT}/next-payment`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getDiscount = async (): Promise<DiscountResponseData> => {
  return client(true, true)
    .get<DiscountResponseData>(`${BILLING_ENDPOINT}/discount`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getInvoice = async (
  transactionId: string
): Promise<{ data: { url: string }; request_id: string }> => {
  return client(true, true)
    .get<{ data: { url: string }; request_id: string }>(`${BILLING_ENDPOINT}/invoice/${transactionId}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getBillingData = async (): Promise<BillingDataResponse> => {
  return client(true, true)
    .get<BillingDataResponse>(`${BILLING_ENDPOINT}/billing-data`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const saveBillingData = async (data: any): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`${BILLING_ENDPOINT}/billing-data`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const generateReport = async (data: any): Promise<string> => {
  try {
    const response = await client(true, true).post<string>(`${BILLING_ENDPOINT}/report`, data);
    if (!response.data) {
      throw new Error('No report URL returned');
    }
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getReports = async (): Promise<BillingReport[] | []> => {
  return client(true, true)
    .get<BillingReport[]>(`${BILLING_ENDPOINT}/reports`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const downloadReport = async (reportId: string): Promise<string> => {
  return client(true, true)
    .get<string>(`${BILLING_ENDPOINT}/report/${reportId}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const createPortalSession = async (subscriptionIds?: string[]): Promise<{ url: string }> => {
  return client(true, true)
    .post<{ url: string }>(`${BILLING_ENDPOINT}/portal-session`, { subscriptionIds })
    .then((response) => response.data);
};
